import React from "react";
import ScreenerHeader from "./ScreenerHeader";
import TherapistProfiles from "./TherapistProfiles";
import completeIllustration from "../../assets/screener/ped-screener-complete.png";

type CompleteScreenProps = {
  readonly onReset: () => void;
};

export default function CompleteScreen({ onReset }: CompleteScreenProps) {
  return (
    <section className="screener-step screener-step--complete" aria-label="Thank you">
      <ScreenerHeader />

      <div className="screener-card screener-thankyou">
        <img className="screener-thankyou__illustration" src={completeIllustration} alt="" aria-hidden="true" />
        <h1 className="screener-heading screener-thankyou__title">Thank you!</h1>
        <p className="screener-thankyou__body">Please return the tablet to the front desk.</p>
      </div>

      <TherapistProfiles />

      <button type="button" className="screener-secondary-link screener-restart" onClick={onReset}>
        Start new screener
      </button>
    </section>
  );
}
